export default "__VITE_ASSET__Dgm4D4Js__"